import React from "react";
import ReactDOM from "react-dom";
import "./ImageModal.css";

const ImageModal = ({ image, isOpen, onClose }) => {
  if (!isOpen || !image) return null;

  return ReactDOM.createPortal(
    <div className="image-modal-overlay" onClick={onClose}>
      <div
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={image} alt="Full view" />
        <button className="image-modal-close" onClick={onClose}>
          ✕
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ImageModal;
